/**
 * theme.js — Amritksheer Shopify Theme v1.1
 * Mobile-optimised: hamburger, swipe gestures, touch-friendly interactions,
 * AJAX cart, PDP gallery/variants/qty, scroll reveal, search overlay, accordion
 */

(function () {
  'use strict';

  /* ════════════════════════════════════
     SCROLL REVEAL (IntersectionObserver)
  ════════════════════════════════════ */
  function initReveal() {
    var revealEls = document.querySelectorAll('.reveal');

    // Safety net: make ALL reveals visible after 2.5s in case IO fails
    var safetyTimer = setTimeout(function () {
      revealEls.forEach(function (el) { el.classList.add('visible'); });
    }, 2500);

    if (!('IntersectionObserver' in window)) {
      clearTimeout(safetyTimer);
      revealEls.forEach(function (el) { el.classList.add('visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px 0px 0px' });

    // Immediately show elements already in viewport on load
    revealEls.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('visible');
      } else {
        io.observe(el);
      }
    });

    // Cancel safety timer once all visible
    setTimeout(function () { clearTimeout(safetyTimer); }, 100);
  }

  /* ════════════════════════════════════
     NAV SCROLL SHADOW
  ════════════════════════════════════ */
  function initNavScroll() {
    var header = document.getElementById('siteHeader') || document.querySelector('.site-header');
    if (!header) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          header.classList.toggle('scrolled', window.scrollY > 50);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ════════════════════════════════════
     MOBILE MENU (hamburger + slide)
  ════════════════════════════════════ */
  function initMobileMenu() {
    var btn = document.getElementById('mobileMenuBtn');
    var menu = document.getElementById('mobileMenu');
    if (!btn || !menu) return;

    function openMenu() {
      menu.classList.add('open');
      btn.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-hidden', 'false');
      // Show overlay
      var ov = document.getElementById('mobileMenuOverlay');
      if (ov) ov.style.display = 'block';
    }
    function closeMenu() {
      menu.classList.remove('open');
      btn.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-hidden', 'true');
      var ov = document.getElementById('mobileMenuOverlay');
      if (ov) ov.style.display = 'none';
    }

    btn.addEventListener('click', function () {
      menu.classList.contains('open') ? closeMenu() : openMenu();
    });

    // Close on outside tap
    document.addEventListener('click', function (e) {
      if (menu.classList.contains('open') && !menu.contains(e.target) && !btn.contains(e.target)) {
        closeMenu();
      }
    });

    // Close on overlay tap
    var menuOverlay = document.getElementById('mobileMenuOverlay');
    if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);

    // Close on escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('open')) closeMenu();
    });

    // Swipe left to close menu
    var startX = 0;
    menu.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    menu.addEventListener('touchend', function (e) {
      if (e.changedTouches[0].clientX - startX < -60) closeMenu();
    }, { passive: true });
  }

  /* ════════════════════════════════════
     SEARCH OVERLAY
  ════════════════════════════════════ */
  function initSearch() {
    var toggle = document.getElementById('searchToggle');
    var overlay = document.getElementById('searchOverlay');
    var closeBtn = document.getElementById('searchClose');
    if (!toggle || !overlay) return;

    function openSearch() {
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
      var inp = overlay.querySelector('.search-input');
      if (inp) setTimeout(function () { inp.focus(); }, 100);
      
    }
    function closeSearch() {
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden', 'true');
      
    }

    toggle.addEventListener('click', openSearch);
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeSearch(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });
  }

  /* ════════════════════════════════════
     ACCORDION
  ════════════════════════════════════ */
  function initAccordion() {
    document.querySelectorAll('.accordion-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = this.closest('.accordion-item');
        var body = item.querySelector('.accordion-body');
        var isOpen = item.classList.contains('open');

        // Close all others in same group (optional - remove for multi-open)
        var siblings = (item.parentElement || document).querySelectorAll('.accordion-item');
        siblings.forEach(function (sib) {
          if (sib !== item && sib.classList.contains('open')) {
            sib.classList.remove('open');
            sib.querySelector('.accordion-trigger') && sib.querySelector('.accordion-trigger').setAttribute('aria-expanded', 'false');
            var sibBody = sib.querySelector('.accordion-body');
            if (sibBody) sibBody.hidden = true;
          }
        });

        item.classList.toggle('open', !isOpen);
        this.setAttribute('aria-expanded', !isOpen);
        if (body) body.hidden = isOpen;
      });
    });
  }

  /* ════════════════════════════════════
     PDP GALLERY (thumbnail switcher)
  ════════════════════════════════════ */
  function initPDPGallery() {
    var mainImg = document.getElementById('mainProductImg');
    if (!mainImg) return;

    document.querySelectorAll('.pdp-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = this.dataset.src;
        if (src) {
          mainImg.style.opacity = '0';
          mainImg.style.transform = 'scale(1.02)';
          setTimeout(function () {
            mainImg.src = src;
            mainImg.style.opacity = '';
            mainImg.style.transform = '';
          }, 150);
          document.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('active'); });
          this.classList.add('active');
        }
      });
    });

    // Swipe to change gallery image on mobile
    var wrap = document.querySelector('.pdp-main-image-wrap');
    if (!wrap) return;
    var touchStartX = 0;
    var thumbs = Array.from(document.querySelectorAll('.pdp-thumb'));
    wrap.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) < 40) return;
      var current = thumbs.findIndex(function (t) { return t.classList.contains('active'); });
      var next = diff > 0 ? Math.min(current + 1, thumbs.length - 1) : Math.max(current - 1, 0);
      if (next !== current) thumbs[next].click();
    }, { passive: true });
  }

  /* ════════════════════════════════════
     PDP QUANTITY CONTROL
  ════════════════════════════════════ */
  function initQty() {
    document.querySelectorAll('.qty-control').forEach(function (ctrl) {
      var input = ctrl.querySelector('.qty-input');
      if (!input) return;

      var minusBtn = ctrl.querySelector('.qty-minus');
      var plusBtn = ctrl.querySelector('.qty-plus');

      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          var v = parseInt(input.value) || 1;
          input.value = Math.max(1, v - 1);
          input.dispatchEvent(new Event('change'));
        });
      }
      if (plusBtn) {
        plusBtn.addEventListener('click', function () {
          var v = parseInt(input.value) || 1;
          var max = parseInt(input.max) || 99;
          input.value = Math.min(max, v + 1);
          input.dispatchEvent(new Event('change'));
        });
      }

      // Prevent manual entry of 0 or negative
      input.addEventListener('change', function () {
        var v = parseInt(this.value);
        if (isNaN(v) || v < 1) this.value = 1;
      });
    });
  }

  /* ════════════════════════════════════
     PDP VARIANT SELECTION
  ════════════════════════════════════ */
  function initVariants() {
    if (typeof window.productData === 'undefined') return;
    var variants = window.productData.variants;
    if (!variants || !variants.length) return;

    // selectedOptions keyed by position string "1","2","3"
    var selectedOptions = {};

    // Pre-populate from first available variant using option1/option2/option3
    var firstVariant = variants.find(function (v) { return v.available; }) || variants[0];
    if (firstVariant) {
      if (firstVariant.option1) selectedOptions['1'] = firstVariant.option1;
      if (firstVariant.option2) selectedOptions['2'] = firstVariant.option2;
      if (firstVariant.option3) selectedOptions['3'] = firstVariant.option3;
    }

    document.querySelectorAll('.ak-var-btn, .option-btn, .var-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = this.dataset.optionPosition; // "1", "2", or "3"
        var val = this.dataset.value;
        selectedOptions[pos] = val;

        // Update active state within same option group
        var container = this.closest('.ak-pdp-var-options, .option-values, .pdp-var-options');
        if (container) container.querySelectorAll('.ak-var-btn, .option-btn, .var-btn').forEach(function (b) {
          b.classList.toggle('active', b.dataset.value === val);
        });

        // Find matching variant using option1/option2/option3
        var matched = variants.find(function (v) {
          var m1 = !selectedOptions['1'] || v.option1 === selectedOptions['1'];
          var m2 = !selectedOptions['2'] || v.option2 === selectedOptions['2'];
          var m3 = !selectedOptions['3'] || v.option3 === selectedOptions['3'];
          return m1 && m2 && m3;
        });

        if (matched) {
          updatePrice(matched);
          updateATCButton(matched);
          updateGalleryForVariant(matched);
          // Mark sold-out sibling options visually
          updateSoldOutVariantButtons(matched, pos);
        }
      });
    });
  }

  function updatePrice(variant) {
    // Covers all template price element IDs
    var priceEl = document.getElementById('pdpPrice') ||
                  document.getElementById('oiPrice') ||
                  document.getElementById('mkPrice') ||
                  document.getElementById('cdPrice');
    var compareEl = document.getElementById('pdpOrig') ||
                    document.getElementById('oiOrig') ||
                    document.getElementById('mkOrig') ||
                    document.getElementById('cdOrig');
    var badgeEl = document.getElementById('pdpSave') ||
                  document.getElementById('oiSave') ||
                  document.getElementById('mkSave') ||
                  document.getElementById('cdSave');

    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        if (badgeEl) { badgeEl.textContent = 'Save ' + pct + '%'; badgeEl.style.display = ''; }
      } else {
        compareEl.style.display = 'none';
        if (badgeEl) badgeEl.style.display = 'none';
      }
    }
  }

  function updateATCButton(variant) {
    // Support all template-specific ATC button IDs
    var atcBtn = document.getElementById('pdpAddToCart') ||
                 document.getElementById('oiATC') ||
                 document.getElementById('mkATC') ||
                 document.getElementById('cdATC');
    if (!atcBtn) return;
    atcBtn.dataset.variantId = variant.id;
    if (variant.available) {
      atcBtn.disabled = false;
      atcBtn.innerHTML = '🛒 Add to Cart';
      // Hide back-in-stock form if visible
      var bisForm = document.getElementById('backInStockForm');
      if (bisForm) bisForm.style.display = 'none';
    } else {
      atcBtn.disabled = true;
      atcBtn.innerHTML = 'Sold Out';
      // Show back-in-stock notification form
      var bisForm = document.getElementById('backInStockForm');
      if (bisForm) bisForm.style.display = 'block';
    }
    // Also sync buy now button
    var buyNowBtn = document.getElementById('pdpBuyNow') ||
                    document.getElementById('oiBuyNow') ||
                    document.getElementById('mkBuyNow') ||
                    document.getElementById('cdBuyNow');
    if (buyNowBtn) {
      buyNowBtn.dataset.variantId = variant.id;
      buyNowBtn.disabled = !variant.available;
    }
  }

  function updateSoldOutVariantButtons(selectedVariant, changedPos) {
    var variants = window.productData && window.productData.variants;
    if (!variants) return;
    // For each option group that is NOT the one just changed, mark buttons
    // as sold-out if no available variant exists with that combination
    document.querySelectorAll('.ak-var-btn, .option-btn, .var-btn').forEach(function(btn) {
      var pos = btn.dataset.optionPosition;
      if (pos === changedPos) return; // don't re-mark the group just clicked
      var val = btn.dataset.value;
      // Build hypothetical selection with this value
      var testOptions = {};
      document.querySelectorAll('.ak-var-btn.active, .option-btn.active').forEach(function(a) {
        testOptions[a.dataset.optionPosition] = a.dataset.value;
      });
      testOptions[pos] = val;
      var hasAvailable = variants.some(function(v) {
        var m1 = !testOptions['1'] || v.option1 === testOptions['1'];
        var m2 = !testOptions['2'] || v.option2 === testOptions['2'];
        var m3 = !testOptions['3'] || v.option3 === testOptions['3'];
        return m1 && m2 && m3 && v.available;
      });
      btn.classList.toggle('sold-out', !hasAvailable);
      btn.disabled = !hasAvailable;
    });
  }

  function updateGalleryForVariant(variant) {
    if (!variant.featured_image) return;
    var mainImg = document.getElementById('mainProductImg') ||
                  document.getElementById('pdpMainImg') ||
                  document.getElementById('oiMainImg') ||
                  document.getElementById('mkMainImg') ||
                  document.getElementById('cdMainImg');
    if (!mainImg) return;
    var newSrc = variant.featured_image.src;
    if (newSrc && mainImg.src !== newSrc) {
      mainImg.src = newSrc;
      document.querySelectorAll('.pdp-thumb').forEach(function (t) {
        t.classList.toggle('active', t.dataset.src && t.dataset.src.includes(variant.featured_image.src.split('?')[0]));
      });
    }
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ════════════════════════════════════
     ADD TO CART (AJAX)
  ════════════════════════════════════ */
  function initAddToCart() {
    // Universal ATC button selector — covers all product templates
    var pdpBtn = document.getElementById('pdpAddToCart') ||
                 document.getElementById('oiATC') ||
                 document.getElementById('mkATC') ||
                 document.getElementById('cdATC');

    if (pdpBtn) {
      // Ensure variant id is populated on ATC button from productData if missing
      if (!pdpBtn.dataset.variantId && window.productData) {
        var firstAvail = window.productData.variants.find(function(v){ return v.available; }) || window.productData.variants[0];
        if (firstAvail) pdpBtn.dataset.variantId = firstAvail.id;
      }
      pdpBtn.addEventListener('click', function () {
        var variantId = this.dataset.variantId || this.dataset.productId;
        var qtyInput = document.getElementById('pdpQtyVal') || document.getElementById('pdpQty') ||
                       document.getElementById('oiQty') || document.getElementById('mkQty') ||
                       document.getElementById('cdQty');
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value) || 1) : 1;
        addToCartAjax(variantId, qty, this);
      });
    }

    // Universal Buy Now — covers all template-specific IDs
    var buyNowBtn = document.getElementById('pdpBuyNow') ||
                    document.getElementById('oiBuyNow') ||
                    document.getElementById('mkBuyNow') ||
                    document.getElementById('cdBuyNow');

    if (buyNowBtn) {
      // Sync variant id from ATC button or productData
      if (!buyNowBtn.dataset.variantId) {
        if (pdpBtn && pdpBtn.dataset.variantId) {
          buyNowBtn.dataset.variantId = pdpBtn.dataset.variantId;
        } else if (window.productData) {
          var firstAvail2 = window.productData.variants.find(function(v){ return v.available; }) || window.productData.variants[0];
          if (firstAvail2) buyNowBtn.dataset.variantId = firstAvail2.id;
        }
      }
      buyNowBtn.addEventListener('click', function () {
        var variantId = (pdpBtn && pdpBtn.dataset.variantId) || this.dataset.variantId || this.dataset.productId;
        var qtyInput = document.getElementById('pdpQtyVal') || document.getElementById('pdpQty') ||
                       document.getElementById('oiQty') || document.getElementById('mkQty') ||
                       document.getElementById('cdQty');
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value) || 1) : 1;
        if (!variantId) return;
        this.disabled = true;
        this.textContent = 'Processing…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        })
        .then(function (r) { if (!r.ok) throw new Error('Cart error'); return r.json(); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () {
          buyNowBtn.disabled = false;
          buyNowBtn.textContent = '⚡ Buy it Now';
          alert('Could not process. Please try again.');
        });
      });
    }

    // Quick-add buttons on product cards
    document.querySelectorAll('.add-to-cart-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = this.dataset.variantId || this.dataset.productId;
        if (variantId) addToCartAjax(variantId, 1, this);
      });
    });
  }

  function addToCartAjax(variantId, qty, btn) {
    if (!variantId) return;
    var originalContent = btn.innerHTML;
    var originalBg = btn.style.background;
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Cart error');
      return r.json();
    })
    .then(function () {
      btn.innerHTML = '✓';
      btn.style.background = 'var(--clr-primary-dark)';
      updateCartCount();
      showCartNotification();
      // Haptic feedback on mobile
      if (navigator.vibrate) navigator.vibrate(50);
      setTimeout(function () {
        btn.innerHTML = originalContent;
        btn.style.background = originalBg;
        btn.disabled = false;
      }, 1600);
    })
    .catch(function () {
      btn.innerHTML = originalContent;
      btn.style.background = originalBg;
      btn.disabled = false;
      alert('Could not add to cart. Please try again.');
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.ak-cart-bubble').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }

  function showCartNotification() {
    var notif = document.getElementById('cartNotification');
    if (!notif) return;
    notif.hidden = false;
    clearTimeout(notif._hideTimer);
    notif._hideTimer = setTimeout(function () { notif.hidden = true; }, 4000);
    var closeBtn = document.getElementById('cartNotifClose');
    if (closeBtn) closeBtn.onclick = function () { notif.hidden = true; };
  }

  /* ════════════════════════════════════
     CART PAGE — QTY UPDATE
  ════════════════════════════════════ */
  function initCartPage() {
    // Qty buttons with data-key attribute (cart page)
    document.querySelectorAll('[data-key].qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.dataset.key;
        var qty = parseInt(this.dataset.qty);
        if (isNaN(qty)) return;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
        }).then(function () { window.location.reload(); });
      });
    });
  }

  /* ════════════════════════════════════
     COLLECTION SORT
  ════════════════════════════════════ */
  function initSort() {
    var sel = document.getElementById('sortSelect');
    if (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    }
  }

  /* ════════════════════════════════════
     WISHLIST (localStorage)
  ════════════════════════════════════ */
  function initWishlist() {
    document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
      var id = btn.dataset.productId;
      if (!id) return;
      var saved = getWishlist();
      if (saved.includes(id)) btn.textContent = '♥';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var list = getWishlist();
        var idx = list.indexOf(id);
        if (idx === -1) { list.push(id); btn.textContent = '♥'; }
        else { list.splice(idx, 1); btn.textContent = '♡'; }
        try { localStorage.setItem('ak_wishlist', JSON.stringify(list)); } catch (err) {}
        if (navigator.vibrate) navigator.vibrate(30);
      });
    });
  }
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('ak_wishlist') || '[]'); } catch (e) { return []; }
  }

  /* ════════════════════════════════════
     STICKY ADD-TO-CART BAR (mobile)
     Shows a sticky "Add to Cart" bar when the main ATC button scrolls out of view
  ════════════════════════════════════ */
  function initStickyATC() {
    var mainBtn = document.getElementById('pdpAddToCart');
    if (!mainBtn) return;

    // Create sticky bar
    var bar = document.createElement('div');
    bar.className = 'sticky-atc-bar';
    bar.innerHTML = '<span class="sticky-atc-title" id="stickyPdpTitle"></span>' +
      '<button class="btn btn-orange sticky-atc-btn" id="stickyATCBtn">Add to Cart</button>';
    bar.style.cssText = 'display:none;position:fixed;bottom:0;left:0;right:0;z-index:800;background:#fff;' +
      'padding:0.8rem 5%;padding-bottom:max(0.8rem,env(safe-area-inset-bottom));' +
      'box-shadow:0 -4px 20px rgba(0,0,0,.12);display:flex;align-items:center;' +
      'justify-content:space-between;gap:1rem;transform:translateY(100%);' +
      'transition:transform 0.3s ease;';
    document.body.appendChild(bar);

    // Set title
    var titleEl = document.querySelector('.pdp-title');
    var stickyTitleEl = bar.querySelector('#stickyPdpTitle');
    if (titleEl && stickyTitleEl) {
      stickyTitleEl.style.cssText = 'font-size:.82rem;font-weight:600;color:#1a3617;flex:1;' +
        'overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';
      stickyTitleEl.textContent = titleEl.textContent.trim().substring(0, 50);
    }

    // Observe main button visibility
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        bar.style.transform = visible ? 'translateY(100%)' : 'translateY(0)';
      }, { threshold: 0.1 });
      io.observe(mainBtn);
    }

    // Wire sticky button
    var stickyBtn = bar.querySelector('#stickyATCBtn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var variantId = mainBtn.dataset.variantId || mainBtn.dataset.productId;
        var qtyInput = document.getElementById('pdpQtyVal') || document.getElementById('pdpQty');
        var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
        addToCartAjax(variantId, qty, stickyBtn);
      });
    }
  }

  /* ════════════════════════════════════
     ANNOUNCEMENT BAR — pause on hover/touch
  ════════════════════════════════════ */
  function initTicker() {
    var ticker = document.querySelector('.ticker-inner');
    if (!ticker) return;
    ticker.addEventListener('mouseenter', function () { this.style.animationPlayState = 'paused'; });
    ticker.addEventListener('mouseleave', function () { this.style.animationPlayState = 'running'; });
    ticker.addEventListener('touchstart', function () { this.style.animationPlayState = 'paused'; }, { passive: true });
    ticker.addEventListener('touchend', function () { this.style.animationPlayState = 'running'; }, { passive: true });
  }

  /* ════════════════════════════════════
     LAZY IMAGE LOADING FALLBACK
  ════════════════════════════════════ */
  function initLazyImages() {
    if ('loading' in HTMLImageElement.prototype) return; // Native lazy loading supported
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var img = e.target;
          if (img.dataset.src) { img.src = img.dataset.src; delete img.dataset.src; }
          io.unobserve(img);
        }
      });
    });
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) { io.observe(img); });
  }

  /* ════════════════════════════════════
     INIT ALL
  ════════════════════════════════════ */

  // Restore scroll on page show (handles bfcache / back navigation)
  window.addEventListener('pageshow', function () {
    
    document.body.style.overflowY = '';
  });
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initNavScroll();
    initMobileMenu();
    initSearch();
    initAccordion();
    initPDPGallery();
    initQty();
    initVariants();
    initAddToCart();
    initCartPage();
    initSort();
    initWishlist();
    initStickyATC();
    initTicker();
    initLazyImages();
  });

})();
